<!-- 首页//用能趋势分析  -->
<template>
  <div class="box">
    <Title :text="electricity.EnergyConsumptionTrend.Title[0]" :engText="electricity.EnergyConsumptionTrend.Title[1]"></Title>
     <div class="content">
      <div class="content-title">
        <div class="a1">
          [
          <div :class="`${active === 1 ? 'active' : ''}`" @click="fn1(1)">本日</div>
          <div :class="`${active === 2 ? 'active' : ''}`" @click="fn1(2)">本月</div>
          <div :class="`${active === 3 ? 'active' : ''}`" @click="fn1(3)">本年</div>
          ]
        </div>
      </div>
      <div class="echarts-content">
      <chart-block ref="chart"></chart-block>
    </div>
    </div>
  </div>
</template>

<script>
import Title from '../../components/title/index.vue';
import { mapState,mapActions } from 'pinia' //引入映射函数
import useStore from '@/store/index' //引入store
export default {
  components: {
    Title,
  },
  computed:{
    ...mapState(useStore,['electricity']) 
  },
 data () {
    return {
      // active 1:日，2:月，3:年
      active:1,
    }
  },
  mounted () {
    this.$refs.chart.setOption(this.electricity.EnergyConsumptionTrend.Option);
  },
  methods: {
    fn1(i){
      this.active = i;
    }
  }
}
</script>

<style scoped>
.box{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content{
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content-title{
  width: 100%;
  height: 24px;
  display: flex;
  flex-direction: column;
}
.content-title .a1{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-title .a1 > div{
  margin: 0px 10px;
  font-size: 12px;
  cursor: pointer;
}
.active{
  text-shadow: 0px 4px 5px #488dff;
}
</style>